<script>
import { defineComponent, ref } from "@vue/composition-api";
import { watch } from "@vue/runtime-dom";
import { Fragment } from "vue-fragment";

export default defineComponent({
  name: "LoadingModalButton",
  props: {
    usingTimeOutSubmit: Boolean,
    disabled: Boolean,
    className: String,
    variant: {
      type: String,
      default: "primary",
    },
  },
  setup(props, { refs, emit }) {
    const isLoading = ref(false);

    const startLoading = () => {
      isLoading.value = true;
      if (props.usingTimeOutSubmit) {
        setTimeout(() => {
          stopLoading();
        }, 1000);
      }
    };
    const stopLoading = () => {
      isLoading.value = false;
    };
    return { isLoading, startLoading, stopLoading };
  },
  components: { Fragment },
});
</script>
<template>
  <b-button
    :style="style"
    :class="className"
    @click="$emit('click')"
    :variant="variant"
    :disabled="isLoading"
  >
    <b-spinner style="margin-right: 5px" v-if="isLoading" small></b-spinner>
    <slot></slot>
  </b-button>
</template>
